import StickyNotification from './StickyNotification';

export default StickyNotification;
